import { Badge } from '@indipia/ui-core';
import type { BadgeStatus } from '@indipia/ui-core';
import type { ChannelCode, ShareState } from './types';

// 공유이력 3메뉴 공통 배지·문구 표준(2026-10-22 확정).
// 커스텀 span 금지 — 전부 표준 Badge 로 그린다.

// ── 열람 상태 — 열람(success) / 미열람(warning) ──
export function ReadBadge({ viewed }: { viewed: boolean }) {
  return (
    <Badge status={viewed ? 'success' : 'warning'} className="whitespace-nowrap">
      {viewed ? '열람' : '미열람'}
    </Badge>
  );
}

/** 다건 수신자 집계 — "k/n 열람" */
export function ReadCountBadge({ viewed, total }: { viewed: number; total: number }) {
  const all = total > 0 && viewed >= total;
  return (
    <Badge status={all ? 'success' : 'warning'} className="whitespace-nowrap">
      {viewed}/{total} 열람
    </Badge>
  );
}

// ── 공유·링크 상태 — 정상(기본) / 취소(danger) / 만료(mute) ──
const SHARE_STATE_LABEL: Record<ShareState, string> = {
  NORMAL: '정상',
  REVOKED: '취소',
  EXPIRED: '만료',
};

export function ShareStateBadge({ state }: { state: ShareState }) {
  if (state === 'REVOKED') return <Badge status="danger" className="whitespace-nowrap">취소</Badge>;
  if (state === 'EXPIRED') return <Badge status="mute" className="whitespace-nowrap">만료</Badge>;
  return <Badge className="whitespace-nowrap">정상</Badge>;
}

export function shareStateLabel(state: ShareState): string {
  return SHARE_STATE_LABEL[state];
}

// ── 매체(채널) — 카카오 / 문자 / 메일 ──
const CHANNEL_LABEL: Record<string, string> = {
  KAKAO: '카카오',
  SMS: '문자',
  EMAIL: '메일',
};
const CHANNEL_STATUS: Record<string, BadgeStatus> = {
  KAKAO: 'warning',
  SMS: 'info',
  EMAIL: 'success',
};

export function channelLabel(channel: ChannelCode | null | undefined): string {
  if (!channel) return '-';
  return CHANNEL_LABEL[channel] ?? channel;
}

export function ChannelBadge({ channel }: { channel: ChannelCode | null | undefined }) {
  if (!channel) return <span className="text-body-sm text-text-muted">-</span>;
  const label = CHANNEL_LABEL[channel] ?? channel;
  const status = CHANNEL_STATUS[channel];
  return <Badge status={status} className="whitespace-nowrap">{label}</Badge>;
}
